
WB.WidgetGrids = WB.WidgetGrids || {};

WB.WidgetGrids.WidgetGridWidgetItemDirectiveLink = function (scope, element, attr) {
};

WB.WidgetGrids.WidgetGridWidgetItemDirective = function () {
    return {
        scope: {
            widget: '='
        },
        replace: true,
        restrict: 'AE',
        link: WB.WidgetGrids.WidgetGridWidgetItemDirectiveLink,
        template: `<li class="widget-grid__widget js-widget-item"
        data-widget-position="{{ widget.Position }}">
        <div class="{{ 'widget widget--' + widget.Type }}"
            data-widget-type="{{ widget.Type }}">
            <div
                wb-widget
                widget="widget"></div>
        </div>
    </li>`
    };
};
WB.App.directive('wbWidgetGridWidgetItem', WB.WidgetGrids.WidgetGridWidgetItemDirective);
